import React, { Fragment } from "react";
import Hero from "./hero";
import Scrollbar from "../../components/scrollbar/scrollbar";
import OurValues from "./OurValues";
import Disclaimer from "./Disclaimer";
import OurServices from "./ourServices";
import Careers from "./careers";
import FunFact from "../../components/funfact/FunFact";
import AboutOverview from "./AboutOverview";
import Testimonial from "../../components/Testimonial/Testimonial";

const HomePage = () => {
  return (
    <Fragment>
      <Hero />
      <AboutOverview />
      <Disclaimer />
      <OurServices />
      <FunFact theme="light" />
      <OurValues showTitle={true} theme="light" />
      <Careers />
      <Scrollbar />
    </Fragment>
  );
};
export default HomePage;
